import React, { useEffect, useRef } from "react";
import clsx from "clsx";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  setDrivers,
  setImported,
  setProject
} from "../../store/actions/project";
import { setLoadingImport } from "../../store/actions/loading";
import API from "../../utils/axios";

import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { Link as RouterLink } from "react-router-dom";
import xlsxExampleFile from "../data/import/sample-drivers.xlsx";
import DataTable from "./DataTable";
import DragAndDrop from "./DragAndDrop";
import ExampleTable from "./ExampleTable";
import BackIcon from "@material-ui/icons/ArrowBack";
import IconButton from "@material-ui/core/IconButton";
import xlsxIcon from "../../assets/images/icons/xlsx-icon.svg";
import Fade from "@material-ui/core/Fade";
import LoadingCircle from "../common/LoadingCircle";
import { driversExample } from "../data/import/examples";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Chip from "@material-ui/core/Chip";
import { Trans } from "react-i18next";
import BlackButton from "../accountDrawer/BlackButton";
import { useSnackbar } from "notistack";
import { useImportStyles } from "./commonStyles";

function ImportDrivers({
  history,
  setImported,
  validDrivers,
  invalidDrivers,
  loadingImport,
  setDrivers,
  setLoadingImport,
  setLoadingImportLeft
}) {
  const classes = useImportStyles();
  const importBody = useRef();
  const validatedData = useRef({});

  const { enqueueSnackbar } = useSnackbar();

  const handleFetch = ({ body, blank }) => {
    if (blank) {
      enqueueSnackbar("The uploaded file is blank.");
      setLoadingImportLeft(false);
      setLoadingImport(false);
      return;
    }

    let drivers = body.filter(
      obj => Object.keys(obj).filter(el => obj[el]).length
    );

    drivers = drivers.map((el, i) => ({
      row: i + 2,
      ...el,
      driver_tags: undefined,
      tags: el.driver_tags?.split(";").map(item => item.trim()) || null
    }));

    setLoadingImportLeft(true);
    API.post(`/v1/drivers/validation`, drivers)
      .then(res => {
        console.log(res);
        validatedData.current = res.data;
        res.data.valid = res.data.valid.map(item => {
          const { first_name, last_name, email, mobile_number, tags } = item;
          return {
            first_name,
            last_name,
            email,
            mobile_number,
            driver_tags: tags?.join("; ")
          };
        });
        res.data.invalid = res.data.invalid.map(item => {
          const { first_name, last_name, email, mobile_number, tags } = item;
          return {
            first_name,
            last_name,
            email,
            mobile_number,
            driver_tags: tags?.join("; ")
          };
        });
        setImported(res.data.valid, res.data.invalid, "drivers");
        importBody.current.scrollTop = importBody.current.scrollHeight;
      })
      .catch(error => {
        console.log(error);
        if (error && error.status === 400) {
          setImported([], [...validDrivers, ...invalidDrivers], "drivers");
        } else {
          enqueueSnackbar("Something went wrong");
        }
      })
      .finally(() => {
        setLoadingImportLeft(false);
        setLoadingImport(false);
      });
  };

  const handleUpload = () => {
    setLoadingImportLeft(true);
    setLoadingImport(true);

    validatedData.current.valid = validatedData.current.valid.map(el => ({
      ...el,
      driver_tags: undefined,
      tags: el.driver_tags?.split(";").map(item => item.trim()) || null
    }));

    API.post(`/v1/drivers/batch`, validatedData.current.valid || [])
      .then(res => {
        setDrivers(res.data);
        history.replace("/drivers");
      })
      .catch(error => {
        console.dir(error);
        if (error && error.status === 400) {
          setImported([], [...validDrivers, ...invalidDrivers], "drivers");
        } else {
          enqueueSnackbar("Something went wrong");
        }
      })
      .finally(() => {
        setLoadingImportLeft(false);
        setLoadingImport(false);
      });
  };

  useEffect(() => {
    return () => setImported([], []);
  }, [setImported]);

  const fields = [
    { name: "first_name", required: true },
    { name: "last_name", required: true },
    { name: "email", required: true },
    { name: "mobile_number" },
    { name: "driver_tags" }
  ];

  return (
    <div className={classes.root}>
      {/* Loading */}
      <Fade in={loadingImport} mountOnEnter unmountOnExit>
        <LoadingCircle />
      </Fade>

      {/* Header */}
      <Box className={classes.header} display="flex" alignItems="center" px={3}>
        <IconButton
          to={"/drivers"}
          component={RouterLink}
          data-cy="drivers-closeUpload"
          className={classes.backButton}
        >
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100%"
          >
            <BackIcon />
          </Box>
        </IconButton>

        <Typography variant="h5" className={classes.title}>
          <Trans i18nKey="uploadDrivers">Upload drivers</Trans>
        </Typography>
      </Box>

      <Box className={classes.body} ref={importBody} pt={4} pb={5}>
        {validDrivers.length + invalidDrivers.length > 0 ? (
          <Box px={3}>
            {validDrivers.length ? (
              <Box
                style={{
                  overflow: "auto",
                  backgroundColor: "rgb(250, 250, 250)",
                  borderRadius: 4,
                  border: "1px dashed rgb(238, 238, 238)"
                }}
                py={1.5}
                px={1}
                mb={2}
              >
                <Typography>Valid rows</Typography>

                <DataTable
                  tableData={validDrivers}
                  validRows
                  services={false}
                />
              </Box>
            ) : null}

            {invalidDrivers.length ? (
              <>
                <Box
                  style={{
                    overflow: "auto",
                    backgroundColor: "rgb(250, 250, 250)",
                    borderRadius: 4,
                    border: "1px dashed rgb(238, 238, 238)"
                  }}
                  py={1.5}
                  px={1}
                  mb={2}
                >
                  <Typography>Invalid rows</Typography>

                  <DataTable
                    tableData={invalidDrivers}
                    invalidRows
                    services={false}
                  />
                </Box>

                <Typography variant="body1">
                  Please check that all required fields are filled out. Also,
                  email addresses need to be unique and can only be linked to 1
                  driver, otherwise invalid rows will be&nbsp;ignored.
                </Typography>
              </>
            ) : null}

            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-end"
              my={3}
            >
              <Button
                component="button"
                onClick={() => {
                  importBody.current.scrollTop = 0;
                  setImported([], []);
                }}
                style={{ marginRight: 8 }}
                className={classes.btn}
              >
                Cancel
              </Button>

              <BlackButton
                disabled={!validDrivers.length}
                handleClick={handleUpload}
                content="Done"
              />
            </Box>
          </Box>
        ) : (
          <>
            {/* Body */}
            <Box pb={2} px={3}>
              <Typography variant="body1" style={{ fontWeight: 500 }}>
                Upload multiple drivers from a file
              </Typography>

              <Typography variant="body2" style={{ color: "#808080" }}>
                Supported file formats: .xls, .xlsx
              </Typography>
            </Box>

            <DragAndDrop
              handleFetch={handleFetch}
              setLoadingImportLeft={setLoadingImportLeft}
              isLeftUpload={Boolean(setLoadingImportLeft)}
            />

            <Box mt={2} px={3}>
              <Box mb={3}>
                <Typography
                  color="secondary"
                  variant="body2"
                  style={{ fontWeight: 600 }}
                >
                  <Trans i18nKey="templateFiles">Template file</Trans>:
                </Typography>

                <Box display="flex" alignItems="center" mt={1}>
                  <Box
                    component="a"
                    display="flex"
                    alignItems="flex-end"
                    color={"#1329FE"}
                    data-cy="driverTemplate"
                    href={xlsxExampleFile}
                    download
                    style={{ textDecoration: "none" }}
                    mr={2}
                  >
                    <Box component="img" src={xlsxIcon} alt="XLSX" mr={0.5} />
                    .XLSX
                  </Box>

                  {/*<Box*/}
                  {/*  component="a"*/}
                  {/*  display="flex"*/}
                  {/*  alignItems="flex-end"*/}
                  {/*  color={blue.A400}*/}
                  {/*  href={xlsxExampleFile}*/}
                  {/*  download*/}
                  {/*  style={{ textDecoration: "none" }}*/}
                  {/*>*/}
                  {/*  <Box component="img" src={csvIcon} alt="CSV" mr={0.5} />*/}
                  {/*  .CSV*/}
                  {/*</Box>*/}
                </Box>
              </Box>
            </Box>

            <Box pt={1} px={3} pb={4} mt={1.25} className={classes.section}>
              <ExpansionPanel defaultExpanded>
                <ExpansionPanelSummary
                  expandIcon={<ExpandMoreIcon data-cy="driver-expandColumns" />}
                  className={classes.panelSummary}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Box>
                    <Box component="p" fontWeight="fontWeightBold">
                      Columns
                    </Box>

                    <Typography variant="body2">
                      Columns should be in the correct order and fields marked
                      in * are required.
                    </Typography>
                  </Box>
                </ExpansionPanelSummary>

                <ExpansionPanelDetails>
                  <Box display="flex" flexWrap="wrap" pt={1}>
                    {fields.map((el, i) => (
                      <Chip
                        key={i}
                        label={`${el.name}${el.required ? "*" : ""}`}
                        className={clsx(classes.chip, {
                          [classes.chipDark]: el.required
                        })}
                      />
                    ))}
                  </Box>
                </ExpansionPanelDetails>
              </ExpansionPanel>
            </Box>

            <Box pt={1} pb={2} px={3} mt={1.25} className={classes.section}>
              <Box component="p" fontWeight="fontWeightBold">
                Example
              </Box>

              <Box
                mt={3}
                mb={1}
                p={1}
                style={{
                  overflow: "auto",
                  backgroundColor: "#F7F7F7",
                  borderRadius: 4,
                  border: "1px dashed #eee"
                }}
              >
                <ExampleTable tableData={driversExample} />
              </Box>
            </Box>
          </>
        )}
      </Box>
    </div>
  );
}

function mapStateToProps(state, props) {
  return {
    project: state.project,
    validDrivers:
      state.project.importedData.type === "drivers"
        ? state.project.importedData.valid
        : [],
    invalidDrivers:
      state.project.importedData.type === "drivers"
        ? state.project.importedData.invalid
        : [],
    loadingImport:
      props.loadingImport === undefined
        ? state.loading.importPage
        : props.loadingImport
  };
}

export default connect(mapStateToProps, {
  setImported,
  setProject,
  setDrivers,
  setLoadingImport
})(withRouter(ImportDrivers));
